
import React from 'react';
import {useTranslation} from "react-i18next";
import {Link} from 'react-router-dom';

function PageNotFound(props) {

    const { t, i18n } = useTranslation()

    return (<div className={'container bg-white p-md-5 p-5 col-md-6 col-12 m-auto vh-100 d-flex align-items-center '}>

        <div className={'lead text-secondary text-start'}>
            <img src="https://cdn.dribbble.com/userupload/21005817/file/original-8e421dad643a0fb2711b2a6182e6f2a5.gif" alt="404" className={'img-fluid'}/>
            <h1>
                {t('404.slogan')}
            </h1>
            <br/>
            <h3>
                <b>
                    {t('404.text.1')}
                </b>
            </h3>
            <p className={'lead'}>
                {t('404.text.2')}
                <br/>
                {t('404.text.3')}
            </p>
            <br/>
            <Link to="/" id={'btn-go-home'} className={'btn bg-dark border rounded-5 col-md-4 col-12 p-3 pt-2 pb-2 text-secondary'}>{t('nav.home')}</Link>
        </div>

    </div>);
}

export default PageNotFound;
